const MultiplicationSignCircleIcon = /*#__PURE__*/ [
  ["path", { d: "M15.5 8.5L12 12M12 12L8.5 15.5M12 12L15.5 15.5M12 12L8.5 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { MultiplicationSignCircleIcon as default };
//# sourceMappingURL=MultiplicationSignCircleIcon.js.map
